import styled from 'styled-components';

export const Header = styled.header`
  height: 48px;
  background: #32404e;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  img {
    height: 27px;
    width: 100px;
  }

  div {
    flex-direction: row;

    button {
      color: #f4f4f4;
      line-height: 50px;
      padding: 0 3px;
      margin: 0 0 0 15px;
      font-weight: 700;
      font-size: 1rem;
    }

    .btn-secondary {
      background-color: transparent;
      border-color: transparent;

      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &:focus {
        background-color: transparent;
        border-color: transparent;
      }
    }
  }
`;

export const Main = styled.main`
  display: flex;
  justify-content: center;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;
  }

  #firstBox {
    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 28px;
      left: 79px;
      font-size: 11px;
      font-weight: bold;
    }
    h4 {
      position: absolute;
      top: 53px;
      left: 89px;
      font-size: 40px;
      color: #869cb3;
      font-weight: 1000;
    }
  }

  #secondBox {
    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 28px;
      left: 69px;
      font-size: 11px;
      font-weight: bold;
    }
    h4 {
      position: absolute;
      top: 53px;
      left: 60px;
      font-size: 40px;
      color: #869cb3;
      font-weight: 1000;
    }
  }

  #spaceOfKill {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 18px;

    img {
      width: 450px;
      padding-bottom: 18px;
    }
    h3 {
      color: #ffcc00;
      font-size: 19px;
      font-weight: 600;
      margin-bottom: 5px;
    }

    p {
      color: #869cb3;
      font-size: 12px;
      font-weight: 700;
    }

    form {
      background-color: #32404e;
      height: 121px;
      width: 420px;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      margin-top: 10px;
      padding: 10px;

      #bet {
        background-color: #1a2530;
        height: 34px;
        width: 390px;
        border: 0;
        border-radius: 3px;
        color: #f4f4f4;
        text-align: center;
      }

      .button {
        background-color: #63b2e6;
        width: 128px;
        height: 37px;
        border: 0;
        color: #f4f4f4;
        font-size: 17px;
        font-weight: 700;
        border-radius: 20px;
      }
    }
  }
`;

export const TableMain = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  margin-bottom: 25px;

  #LowWidth {
    @media (min-width: 768px) {
      display: none;
    }
  }

  #HighWidth {
    @media (max-width: 768px) {
      display: none;
    }
  }

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;
  }

  .bold {
    font-weight: 700;
    color: #f8f9fa;
    text-decoration: underline;

    :hover {
      color: #b4b5bb;
    }
  }

  .green {
    color: #62c744;
  }

  .gray {
    color: #6b8299;
  }
  table {
    width: 700px;
    height: fit-content;
    border-radius: 7px;
    background-color: #32404e;
    margin-right: 30px;

    @media (max-width: 660px) {
      width: 66vw;
      margin-right: 0;
    }

    td,
    th {
      border-top: 0;
      border-bottom: 0;
      text-align: center;
      width: 100%;
    }

    thead {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5px;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #6b8299;
        border-radius: 5px;
        height: 35px;
      }
    }
    tbody {
      display: flex;
      flex-direction: column;
      align-items: center;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-radius: 20px;
        height: 57px;

        div {
          p {
            padding-right: 3px;
            margin-bottom: 0;
          }
        }
        &:nth-child(2n) {
          background-color: #263340;
        }
        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
`;

export const Footer = styled.footer`
  background: #222f3b;
  height: 316px;

  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  padding-top: 20px;

  .container {
    width: 1120px;
    display: flex;
    justify-content: space-around;
  }

  .bold {
    font-weight: 700;
  }

  .green {
    span {
      color: #62c744;
      font-weight: 700;
    }
  }

  .gray {
    span {
      color: #6b8299;
      font-weight: 700;
    }
  }
  table {
    width: 540px;
    border-radius: 15px;
    background-color: #32404e;

    p {
      margin-bottom: 0;
    }

    td,
    th {
      border-top: 0;
      border-bottom: 0;
    }

    thead {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5px;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #6b8299;
        border-radius: 5px;
        height: 35px;
      }
    }
    tbody {
      display: flex;
      flex-direction: column;
      align-items: center;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 20px;
        height: 35px;

        div {
          p {
            padding-right: 3px;
            margin-bottom: 0;
          }
        }
        &:nth-child(2n) {
          background-color: #263340;
        }
        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
`;
